var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValletWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6865 11.3423C10.6865 12.0013 11.2287 12.5356 11.8974 12.5356C12.5661 12.5356 13.1082 12.0013 13.1082 11.3423C13.1082 10.6832 12.5661 10.1489 11.8974 10.1489C11.2287 10.1489 10.6865 10.6832 10.6865 11.3423Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6897 5.61639C6.30845 5.31718 2.69896 4.67644 1 4.18213V11.3911C1 12.9778 1 13.7712 1.50014 14.4182C2.00028 15.0652 2.68647 15.248 4.05886 15.6135C6.27619 16.2039 8.60686 16.5556 10.6952 16.7567C12.8596 16.9651 13.9418 17.0694 14.7359 16.3542C15.53 15.6389 15.53 14.4901 15.53 12.1921V10.5902C15.53 8.35867 15.53 7.24293 14.8785 6.55045C14.2271 5.85797 13.048 5.77744 10.6897 5.61639Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8063 5.77342C13.1112 4.64111 13.3871 2.58177 12.5651 1.55922C12.0441 0.911109 11.2697 0.973378 10.5105 1.03919C6.51971 1.3851 3.70051 2.08779 2.12447 2.56518C1.44678 2.77046 1 3.42269 1 4.15081",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValletWhite);
export default __webpack_public_path__ + "static/media/vallet-white.7c36199c4d20a6c7ed8619db392a31b9.svg";
export { ForwardRef as ReactComponent };